// ============================================================
// Rilevamento dispositivi touch (smartphone/tablet): il puntatore
// primario è "coarse" (dito) e non c'è hover. Sui touch cambiano i
// controlli: joystick virtuale + trascina per guardarti intorno,
// niente pointer lock, effetti pesanti disattivati.
// ============================================================
export const IS_TOUCH =
  typeof window !== 'undefined' &&
  window.matchMedia('(pointer: coarse)').matches
